//@ts-check
//@ts-ignore
import PcSub from './pc-sub.riot';
import { connect } from '@/common/lib/riot-redux';
export default connect(PcSub);